import {vue} from "../../../main";

export const providersModule = {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetchAllProviders(actions, {page, buids, amount, filter, sortcolumn, sortby}) {
            // console.log("fetchAllProviders", {page, amount, filter, sortcolumn, sortby});
            let params = {
                buids: (buids ||  actions.rootGetters['data/getSelectedBranchesIds']).join(","),
                page,
                amount,
                sortcolumn,
                sortby
            };
            return this.$api.baseApi().post('/providers/get/all', filter, {params})
                .then(response => {
                    return response.data?.objects;
                }).catch(error => {
                    actions.dispatch('notifications/error',
                        {
                            title: {text: '%s - failed to retrieve', arguments: ['provider']},
                            message: (typeof error === "object" && error.message !== undefined ? error.message : error)
                        },
                        {root: true});
                    return error;
                });
        },
        fetchProviderById(actions, id) {
            return this.$api.baseApi().get(`/providers/get/${id}`)
                .then(response => {
                    return response.data?.objects.provider;
                }).catch(error => {
                    actions.dispatch('notifications/error',
                        {
                            title: {text: '%s - failed to retrieve', arguments: ['provider']},
                            message: (typeof error === "object" && error.message !== undefined ? error.message : error)
                        },
                        {root: true});
                    return error;
                });
        },
        insertProviders(actions, request) {
            return this.$api.baseApi().post(`/providers/add`, request)
                .then(response => {
                    actions.dispatch('notifications/success',
                        {
                            title: 'Inserted provider',
                            message: 'Task updated successfully',
                        },
                        {root: true});
                    return response.data?.objects.provider;
                }).catch(error => {
                    actions.dispatch('notifications/error',
                        {
                            title: {text: '%s - failed to insert', arguments: ['provider']},
                            message: (typeof error === "object" && error?.response?.data?.message != null ? error.response.data.message : error)
                        },
                        {root: true});
                    throw error?.response?.data;
                });
        },
        updateProviders(actions, {id, request}) {
            return this.$api.baseApi().post(`/providers/update/${id}`, request)
                .then(response => {
                    actions.dispatch('notifications/success',
                        {
                            title: 'Update provider',
                            message: 'Provider updated successfully',
                        },
                        {root: true});
                    return response.data?.objects.provider;
                }).catch(error => {
                    actions.dispatch('notifications/error',
                        {
                            title: {text: '%s - failed to insert', arguments: ['provider']},
                            message: (typeof error === "object" && error?.response?.data?.message != null ? error.response.data.message : error)
                        },
                        {root: true});
                    throw error?.response?.data;
                });
        },
    }
}
